module.exports = __webpack_public_path__ + "static/media/Wellness03.65f0057a.jpeg";